import React from "react";

const AboutUs = () => {
  return (
    <div>
      <h1>
        <span class="orange">About</span>
      </h1>
      <div className="container">
        <p>
          Welcome to our site! <br />
          Thank you so much for visiting our project, we appreciate it greatly.
          For the three of us, it was our very first hackathon, and it was an
          amazing experience. After learning about web vulnerabilities, we set
          ourselves a mission to help developers protect users on their
          platform. Thus began a mission to combat web vulnerabilities and
          protect users. As developers ourselves, we understand the importance
          of creating secure digital environments. Our platform provides tools,
          resources, and knowledge to{" "}
          <span className="orangeFixed">fortify your creations</span> against
          threats. Whether it's educating on best practices or offering
          cutting-edge solutions, we empower developers in the battle for online
          security. <br />
          Join us as we make the web a safer place for all.
        </p>
      </div>{" "}
    </div>
  );
};

export default AboutUs;
